import {
  Dialog,
  DialogContent,
  DialogHeader,
  VideoPlayer,
} from '@duck/ui'
import { ClockIcon } from '@heroicons/react/24/outline'
import { useTar } from '@/modules'

interface WorkspaceTourDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const WORKSPACE_TOUR_VIDEO_SRC =
  'https://www.xp-lab.com/public/app-media/workspace-tour.mp4'
const WORKSPACE_TOUR_POSTER_SRC =
  'https://www.xp-lab.com/public/app-media/workspace-tour-poster.png'

export const WorkspaceTourDialog = ({ open, onOpenChange }: WorkspaceTourDialogProps) => {
  const { t } = useTar()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent width='lg' className="overflow-hidden flex flex-col">
        <DialogHeader>
          <div className="flex items-center justify-center gap-2 text-primary font-medium text-xl mt-1">
            <ClockIcon className="w-4 h-4 flex-shrink-0" aria-hidden />
            <span>{t('workspaceTour.videoCaption')}</span>
          </div>
        </DialogHeader>
        <div className="flex-1 min-h-0 flex items-center justify-center mt-4">
          <VideoPlayer
            src={WORKSPACE_TOUR_VIDEO_SRC}
            poster={WORKSPACE_TOUR_POSTER_SRC}
            className="max-h-[80vh] rounded-md"
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
